import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlternativeComponent } from './alternative/alternative.component';
import { RegisterComponent } from './register/register.component';


const routes: Routes = [
  {
    path: '',
    component: RegisterComponent,
  },
  {
    path: 'alternative',
    component: AlternativeComponent,
  },
  {
    path: ':guid',
    component: RegisterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterRoutingModule { }
